module.exports = __webpack_public_path__ + "img/cancelmeeting.92ec9fbe.svg";